export default "__VITE_ASSET__GZgZ46wf__"